import React from 'react';
import withSize from 'react-sizeme';
import classnames from 'classnames';

import d3 from '../Chart/d3';
import ChartWrapper from '~/core/scripts/chart-components/ChartWrapper';
import YAxis from '~/core/scripts/chart-components/YAxis';
import ChartGrid from '~/core/scripts/chart-components/Grid';
import { slugify } from '~/core/scripts/utils';
import { translate } from '~/core/scripts/chart-components/utils';
import { is768Query, is1200Query } from '~/core/scripts/mediaquery-helper';

const isDesktop = is1200Query();
const isSmallScreen = !is768Query();
const xTicks = [2013, 2014, 2015, 2016, 2017, 2018, 2019].map(value => ({ value: new Date(value, 0, 1), label: value }));
const yTicks = [0, 5, 10, 15, 20, 25, 30].map(value => ({ value, label: value }));
const yAxisTicks = [0, 15, 30].map(value => ({ value, label: value }));
const margin = { top:0, left:0, right: 15, bottom: 1 };

const Chart = withSize()(({ size, data, areaData }) => {
  const { width } = size;
  const height = width * (isSmallScreen ? 0.7 : 0.8);

  if (!data || !areaData) {
    return null;
  }


  const xScale = d3.scaleLinear()
    .domain([new Date(2013, 0, 1), new Date(2019, 7, 26)])
    .range([margin.left, width - margin.right]);

  const yScale = d3.scaleLinear()
    .domain([0, 30])
    .range([height - margin.bottom, margin.top]);

  const area = d3.area()
    .x(d => xScale(d.date))
    .y0(yScale(0))
    .y1(d => yScale(d.value));

  const line = d3.line()
    .x(d => xScale(d.date))
    .y(d => yScale(d.value));

  return (
    <ChartWrapper width={width} height={height}>
      <ChartGrid
        margin={margin}
        width={width}
        height={height}
        y={yScale}
        x={xScale}
        values={{
          x: xTicks,
          y: yTicks
        }}
      />
      <YAxis
        margin={margin}
        width={width}
        height={height}
        ticks={yAxisTicks}
        y={yScale}
        unit="%"
      />
      <g transform={translate(margin.left, margin.top)}>
        <path
          className="chart__area"
          d={area(areaData)}
        />
        <path
          className="chart__line"
          d={line(areaData)}
        />
        {data.map((d, i) => (
          <circle
            key={`dot-${i}`}
            className="chart__dot"
            r={2}
            cx={xScale(d.date)}
            cy={yScale(d.value)}
          />
        ))}
      </g>
    </ChartWrapper>
  );
});

export default (props) => {
  const recentEntry = props.data.reduce((res, item) => {
    if (item.date > res.date) {
      res = item
    }

    return res;
  }, { value: 0, date: new Date(1000, 0, 1) });

  const chartClasses = classnames('minichart', slugify(props.state));
  const avgIconClasses = classnames('minichart__avgicon', { above: props.aboveAvg });

  return (
    <div className={chartClasses}>
      <div className="minichart__title">
        <div className={avgIconClasses} />
        {isDesktop ? props.state : props.stateShort}
      </div>
      <div className="minichart__subtitle">Letzte Umfrage: <strong>{recentEntry.value} %</strong></div>
      <div className="minichart__chart">
        <Chart data={props.data} areaData={props.areaData}/>
      </div>
    </div>
  );
};
